import { isValidTipoConta } from "./IsValidTipoConta";

/**
 * Retorna o melhor contrato_plano_usina disponível com base no valor de desconto para o tipo de conta ou null, caso não haja * @param {planoUsinas} Array -> array de plano-usinas, populado com contrato_plano_usinas, usina, usina.concessionaria.
 * @param {tipoConta} 'pj'|'pf' -> tipo de conta do usuário: pessoa jurídica, pessoa física
 * @returns 
 */
export function filtrarMelhorContratoPlanoUsina({ planoUsinas, tipoConta }) {
  
  if(!isValidTipoConta(tipoConta)) {
    return null;
  }

  if(planoUsinas.length < 1) {
    return null;
  }

  let melhorContratoPlano;
  let planoUsina;
  let contratoPlanoUsinas;
  let contratoPlanoUsina;
  let usina;

  for(let i=0; i<planoUsinas.length; i++) {
    planoUsina = planoUsinas[i];
    contratoPlanoUsinas = planoUsina?.attributes?.contrato_plano_usinas?.data;
    for(let j=0; j<contratoPlanoUsinas.length; j++) {
      contratoPlanoUsina = contratoPlanoUsinas[j];
      if(
          !melhorContratoPlano 
        || 
          contratoPlanoUsina.attributes?.[`desconto_porcentagem_${tipoConta}`] > melhorContratoPlano.attributes?.[`desconto_porcentagem_${tipoConta}`]
      ) {
        melhorContratoPlano = contratoPlanoUsina;
        usina = planoUsinas?.[i]?.attributes?.usina;
      }
    }
  }

  delete melhorContratoPlano.attributes.nome;
  // melhorContratoPlano.usina = usina;
  return {
    ...melhorContratoPlano, 
    attributes: {
      nome_gerador_integrado: usina.data?.attributes?.nome_sharpspring,
      nome_gerador_interno: usina.data?.attributes?.nome, 
      nome: usina.data?.attributes?.nome, 
      ...melhorContratoPlano.attributes,
    }
  };
}